import api from '@/api';
import { ForexCount, ForexCourseByType } from "@/feature/Forex/api/forex.interface";
import { mapForexCount } from "@/feature/Forex/api/forex.utils";

export const $getForexCourse = async (): Promise<ForexCourseByType> => {
	// return require('./__mock__/course.mock.json').data;

	return api
		.get('foreign-exchange/course')
		.then(response => response || { sell: [], buy: [] });
};

export const $getForexCount = async (): Promise<ForexCount> => {
	// return require('./__mock__/template-and-draft-counts.json').data;

	return api
		.get('foreign-exchange/template-and-draft-counts')
		.then(mapForexCount);
};